module.exports = __webpack_public_path__ + "static/media/I5.a9a87547.png";